// import React from 'react'
// import { Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
// import moment from 'moment'
// import DeleteIcon from '@mui/icons-material/Delete';

// const ProductType = () => {
//     return (
//         <Grid className="product__page">
//             <TableContainer component={Paper}>
//                 <Table sx={{ minWidth: 650 }} aria-label="simple table">
//                     <TableHead>
//                         <TableRow>
//                             {['Product Type', 'Is Active', 'Created At', 'Action'].map((header) => (
//                                 <TableCell key={header} style={{ fontWeight: 'bold' }} align="left">{header}</TableCell>
//                             ))}
//                         </TableRow>
//                     </TableHead>
//                     <TableBody>
//                         {[].map((row) => (
//                             <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
//                                 <TableCell align="left">{row.mrp}</TableCell>
//                                 <TableCell align="left">{row.version}</TableCell>
//                                 <TableCell align="left">{moment(row.createdAt).format('LLL')}</TableCell>
//                                 {/* <TableCell align="left">
//                             <IconButton onClick={() => { setDeleteConfirm(true); setDeleteId(row.id); }}>
//                                 <DeleteIcon />
//                             </IconButton>
//                         </TableCell> */}
//                             </TableRow>
//                         ))}
//                     </TableBody>
//                 </Table>
//             </TableContainer>
//         </Grid>
//     )
// }

// export default ProductType

import { Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box, useMediaQuery, useTheme } from '@mui/material';
import moment from 'moment';
import React from 'react';
import DeleteIcon from '@mui/icons-material/Delete';

const ProductType = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const productTypes = []; // Replace with real data when integrating

  return (
    <Grid container spacing={2} padding={2}>
      <Grid item xs={12}>
        <Box sx={{ overflowX: 'auto' }}>
          <TableContainer component={Paper}>
            <Table size={isMobile ? 'small' : 'medium'} aria-label="product type table">
              <TableHead>
                <TableRow>
                  {['Product Type', 'Is Active', 'Created At', 'Action'].map((header) => (
                    <TableCell key={header} sx={{ fontWeight: 'bold', whiteSpace: 'nowrap' }} align="left">
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {productTypes.length > 0 ? (
                  productTypes.map((row, idx) => (
                    <TableRow key={idx}>
                      <TableCell align="left">{row.productType}</TableCell>
                      <TableCell align="left">{row.isActive ? 'Yes' : 'No'}</TableCell>
                      <TableCell align="left">{moment(row.createdAt).format('LLL')}</TableCell>
                      <TableCell align="left">
                        <IconButton onClick={() => console.log('Delete', row.id)}>
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} align="center">No data available</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ProductType;
